module.exports = __webpack_public_path__ + "assets/img/photo.62a4de06.png";